import React, { FC } from 'react';
import { Box, EmptyState, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/fe-essentials-standalone';

type Props = { overrideAction?: () => void };

const GenericErrorState: FC<Props> = ({ overrideAction }) => {
  const { t } = useTranslation();

  function reloadPage() {
    window.location.reload();
  }

  return (
    <Box align="center" verticalAlign="middle" width="100%" height="100%">
      <EmptyState
        dataHook="templates-generic-error-state"
        theme="page-no-border"
        title={t('marketplace.template-general-error-title')}
        subtitle={t('marketplace.template-general-error-subtitle')}
      >
        <TextButton
          prefixIcon={<Refresh />}
          onClick={!!overrideAction ? overrideAction : reloadPage}
        >
          {t('marketplace.template-general-error-cta')}
        </TextButton>
      </EmptyState>
    </Box>
  );
};

export default GenericErrorState;
